import { canTransformToJSON } from './utils';
import ClientError from './ClientError';

let client = null;

class Client {
  static defaultHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };

  static async defaultPrepare(init) {
    return init;
  }

  static async defaultSerialize(init) {
    if (canTransformToJSON(init.body)) {
      init.body = JSON.stringify(init.body);
    }

    return init;
  }

  static async defaultValidate(request, response) {
    if (response.ok) {
      return;
    }

    let message;

    try {
      ({ message } = await response.clone().json());
    } catch (error) {
      message = await response.clone().text();
    }

    throw new ClientError(message ?? 'Failed', {
      request,
      response
    });
  }

  static async defaultParse(response) {
    return await response.json();
  }

  static init(config) {
    const { defaultHeaders, defaultPrepare, defaultSerialize, defaultValidate, defaultParse } = this;
    client = new Client({
      prepare: defaultPrepare,
      serialize: defaultSerialize,
      validate: defaultValidate,
      parse: defaultParse,
      headers: defaultHeaders,
      mode: 'cors',
      cache: 'no-cache',
      ...config
    });
  }

  static request(config) {
    return client.request(config);
  }

  constructor(config) {
    this._config = config;
  }

  async request(config) {
    let { url, baseUrl, headers, prepare, serialize, validate, parse, ...rest } = {
      ...this._config,
      ...config
    };
    url = new URL(url, baseUrl);
    headers = new Headers({ ...this._config.headers, ...headers });
    let init = await prepare({ headers, ...rest });
    init = await serialize(init);
    const request = new Request(url, init);
    const clone = request.clone();
    const response = await fetch(request);
    await validate(clone, response);

    return await parse(response);
  }
}

export default Client;
